/** Labels and formatters of the actuarial analysis (pawer-backend spec 095). */

export const SERVICE_NAMES = {
  CHIP: 'Postura de chip',
  CONSULTA: 'Consulta veterinaria',
  VAC_RAB: 'Vacuna antirrábica',
  VAC_POLI: 'Vacuna polivalente',
  DESPAR: 'Desparasitación',
  EXAMEN: 'Exámenes preventivos',
  PELU: 'Baño y peluquería',
  MEDIC: 'Medicamentos',
  ESTERIL: 'Esterilización',
  CREMA: 'Cremación',
  HOTEL: 'Hotelería / pet sitting',
  URGENCIA: 'Urgencia veterinaria'
};

export const LINE_LABELS = { employee_benefit: 'Employee Benefit', asistencias: 'Asistencias' };

export const SOURCE_LABELS = {
  model: 'Datos reales',
  assumption: 'Supuesto del Sheet',
  unknown: 'Sin datos',
  segment: 'Datos propios',
  fallback: 'Prestado de otro segmento'
};

export const SNAPSHOT_STATUS = { computed: 'Calculada', published: 'Publicada', superseded: 'Reemplazada' };

export function serviceName(code) {
  return SERVICE_NAMES[code] ?? code;
}

export function rangeText(from, to) {
  const f = Number(from).toLocaleString('es-CL');
  return to === null || to === undefined ? `${f}+` : `${f} – ${Number(to).toLocaleString('es-CL')}`;
}

export function pct(value, decimals = 0) {
  if (value === null || value === undefined) return '—';
  return `${(value * 100).toLocaleString('es-CL', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}%`;
}

export function num(value, decimals = 0) {
  if (value === null || value === undefined) return '—';
  return Number(value).toLocaleString('es-CL', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}
